var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfrimcharge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 64,
    viewBox: "0 0 61 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.809 7.19922C49.5188 7.19922 60.6501 18.3306 60.6501 32.0404C60.6501 45.7503 49.5188 56.8816 35.809 56.8816C22.0991 56.8816 10.9678 45.7503 10.9678 32.0404C10.9678 18.3306 22.0991 7.19922 35.809 7.19922Z",
    fill: "#63B993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5636 61.1191C8.64944 55.2226 2 44.4012 2 32.0394C2 22.3434 6.09068 13.5953 12.6391 7.42773",
    stroke: "#82F1D0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9609 6.50081C23.7928 4.11621 28.1996 2.57 32.9237 2.11914",
    stroke: "#82F1D0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2861 5.20237C35.4601 5.1989 35.6342 5.19727 35.809 5.19727",
    stroke: "#82F1D0",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2822 36.5763C23.2822 36.5763 27.6324 42.6436 30.1509 42.5291C32.0212 42.444 40.3318 32.1307 44.4852 26.8281",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfrimcharge);
export default __webpack_public_path__ + "static/media/confrimcharge.d92969da4e8c1243e4dc5838bb8618eb.svg";
export { ForwardRef as ReactComponent };